export const sportConstants = {
    GET_SPORTS_REQUEST: 'GET_SPORTS_REQUEST',
    GET_SPORTS_SUCCESS: 'GET_SPORTS_SUCCESS',
    GET_SPORTS_FAILURE: 'GET_SPORTS_FAILURE',
    SPORT_SELECTED: 'SPORT_SELECTED'
};



// WEBPACK FOOTER //
// ./src/_constants/sports.js